import { DocumentCreateOriginEnum, FileApi, ProjectDocumentsApi } from "@socotec.io/document-sdk";

const DEFAULT_MIME_TYPE = "application/octet-stream";

export const storeFile = async ({ file, configuration }) => {
  const intent = await new FileApi(configuration).presignUploadUrl({
    presignUrlUploadRequest: { contentType: file?.type || DEFAULT_MIME_TYPE },
  });

  const stored = await fetch(intent.url, { method: "PUT", headers: intent.headers, body: file });
  if (!stored.ok) throw new Error(`File upload to storage failed with HTTP ${stored.status}`);

  return { uuid: intent.uuid, fileName: file.name };
};

export const createStoredDocument = ({ stored, form, relatedObjectId, configuration }) =>
  new ProjectDocumentsApi(configuration).create({
    relatedObjectPk: relatedObjectId,
    documentCreate: {
      ...form,
      name: form.name || stored.fileName,
      uuid: stored.uuid,
      origin: DocumentCreateOriginEnum.ObjectStorage,
    },
  });
